<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-textinput
      v-model="resource.key"
      placeholder="Registration Key"
      :error="keyError"
      isRequired
      @input="touch('key')"/>
    <rp-button :disabled="isInvalid" type="primary">Submit</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'
  import Button from '../../../components/ui/inputs/Button'
  import TextInput from '../../../components/ui/inputs/TextInput'

  export default {
    name: 'EnterRegistrationKey',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-textinput': TextInput
    },

    computed: {
      ...errorMessages(['key'])
    },

    validations: {
      resource: {
        key: {
          required,
          minLength: minLength(8),
          maxLength: maxLength(8)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/EnterRegistrationKey.vue